@if (filters.length > 0) {
  <div fxLayout="row" fxLayoutAlign="start start">
    <mat-chip-set>
      <ng-container>
        <mat-chip-set>
          @for (filter of filters; track filter.filterName) {
            <mat-chip-option
              class="filter-chips__chip"
              [selected]="!!filter.selected"
              (selectionChange)="onChipSelectionChange(filter, $event)">
              {{filter.filterName}}
            </mat-chip-option>
          }
        </mat-chip-set>
      </ng-container>
    </mat-chip-set>
  </div>
}
